/* eslint-disable react/prop-types */
import classes from "./composed-view-six.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import classNames from "classnames";

function ComposedViewSix({
  header,
  title,
  preContent,
  columnOneTitle,
  columnOne,
  columnTwoTitle,
  columnTwo,
  subContent,
  className,
}) {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const columns = !columnTwo || isMobile ? "1fr" : "1fr 1fr";

  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames(classes.container, className)}
    >
      {header && (
        <Label
          weight="bold"
          tag="h5"
          color="primary"
          align="start"
          className={classes.header}
        >
          {header}
        </Label>
      )}

      {title && (
        <Label
          weight="bold"
          tag="h2"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {title}
        </Label>
      )}

      {preContent && (
        <Label
          size="md"
          color="secondary"
          align="start"
          className={classes.preContent}
        >
          {preContent}
        </Label>
      )}

      {!columnTwo && (
        <Grid columns={columns} style={{ width: "100%" }}>
          <Flex
            align="flex-start"
            direction="column"
            justify="flex-start"
            style={{ width: "100%" }}
            className={classes.columnOne}
          >
            {columnOneTitle && (
              <Label
                tag="h6"
                align="start"
                weight="bold"
                color="secondary"
                className={classes.columnTitle}
              >
                {columnOneTitle}
              </Label>
            )}
            <Label align="start" size="md" color="secondary">
              {columnOne}
            </Label>
          </Flex>
        </Grid>
      )}

      {columnTwo && (
        <Grid columns={columns} style={{ width: "100%" }}>
          <Flex
            align="flex-start"
            direction="column"
            justify="flex-start"
            style={{ width: "100%" }}
            className={classes.columnOne}
          >
            {columnOneTitle && (
              <Label
                tag="h6"
                align="start"
                weight="bold"
                color="secondary"
                className={classes.columnTitle}
              >
                {columnOneTitle}
              </Label>
            )}
            <Label align="start" size="md" color="secondary">
              {columnOne}
            </Label>
          </Flex>

          <Flex
            align="flex-start"
            direction="column"
            justify="flex-start"
            style={{ width: "100%" }}
            className={classes.columnTwo}
          >
            {columnTwoTitle && (
              <Label
                tag="h6"
                align="start"
                weight="bold"
                color="secondary"
                className={classes.columnTitle}
              >
                {columnTwoTitle}
              </Label>
            )}
            {columnOneTitle && !columnTwoTitle && (
              <Label
                tag="h6"
                align="start"
                weight="bold"
                color="secondary"
                className={classes.columnTitle}
                style={{ opacity: "0%" }}
              >
                -
              </Label>
            )}
            <Label align="start" size="md" color="secondary">
              {columnTwo}
            </Label>
          </Flex>
        </Grid>
      )}

      {subContent && (
        <Label
          size="md"
          color="secondary"
          align="start"
          className={classes.subContent}
        >
          {subContent}
        </Label>
      )}
    </Flex>
  );
}

export default ComposedViewSix;
